<template>
  <div>
    <CardedSectionHeader
      icon="mdi-plus"
      label="Change Info"
      id="owner_update_details_form_section"
    ></CardedSectionHeader>
    <CardedForm
      ref="owner_update_details_form_ref"
      id="owner_update_details_form"
      title="Update Your Account details"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      @on-clear-form="on_clear_form"
    >
      <TextField
        v-model="form.first_name"
        :validation_rules="first_name_rules"
        label="First Name"
        icon="mdi-user"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="form.last_name"
        :validation_rules="last_name_rules"
        label="Last Name"
        icon="mdi-user"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="password"
        :validation_rules="password_rules"
        label="Account Password"
        type="password"
        icon="mdi-key-variant"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
  </div>
</template>


<script>
import TextField from "../../../components/TextField";
import CardedForm from "../../../components/CardedForm";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "OwnerSecurityDetails",
  components: {
    TextField,
    CardedForm,
    CardedSectionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      _user: null,
      errors: [],
      message: "",
      form: {
        first_name: "",
        last_name: "",
      },
      password: "",
      first_name_rules: [
        Utils.validate.is_required("First name is required"),
        Utils.validate.min_max_length(
          3,
          20,
          "First name should be between 3 and 20 characters "
        ),
      ],
      last_name_rules: [
        Utils.validate.is_required("Last name is required"),
        Utils.validate.min_max_length(
          3,
          20,
          "Last name should be between 3 and 20 characters "
        ),
      ],
      password_rules: [
        Utils.validate.is_required("Password is required"),
        Utils.validate.min_max_length(
          6,
          10,
          "Password should be between 6 and 10 characters"
        ),
      ],
    };
  },
  methods: {
    on_auto_fill() {
      this.ini_form();
    },
    on_clear_form() {
      this.ini_form();
    },
    ini_form() {
      this.form.first_name = "";
      this.form.last_name = "";
      this.password = "";
    },
    submit() {
      this.errors = [];
      this.message = "";
      var vm = this;
      this.$emit("on-show-loader");
      ServerClient.Login.login(
        {
          email: vm._user.email,
          password: vm.password,
        },
        (res) => {
          //we have the right credentials
          ServerClient.Security.update_details(
            {
              data: {
                ...vm.form,
              },
              id: vm._user.id,
            },
            (res) => {
              vm.message =
                "Your <b>Account details were updated </b> succesfull";
              this.$refs.owner_update_details_form_ref.show_message_dialog();
            },
            (errors2) => {
              vm.$emit("on-hide-loader");
              vm.errors = errors2;
              vm.$refs.owner_update_details_form_ref.show_error_dialog();
            }
          );
        },
        (errors) => {
          vm.$emit("on-hide-loader");
          vm.errors = errors;
          vm.$refs.owner_update_details_form_ref.show_error_dialog();
        }
      );
    },
    on_hide_message() {
      //login first
      var vm = this;
      vm.$emit("on-show-loader");
      ServerClient.Login.login(
        {
          email: vm._user.email,
          password: vm.password,
        },
        (res) => {
          //we have to refresh the page
          vm.$router.go(0);
        },
        (errors) => {
          vm.$emit("on-hide-loader");
          vm.errors = errors;
          vm.$refs.owner_update_details_form_ref.show_error_dialog();
        }
      );
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "Security User Details Management",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Security",
          disabled: false,
          href: "/owner/security",
        },
        {
          text: "details",
          disabled: true,
          href: "/owner/security/details/update",
        },
      ],
    });

    this.ini_form();
  },
};
</script>